'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getRehydrationIndex;
var SELECTOR_PREFIX_REGEXP = /^[a-z0-9_-]*$/gi;

function getRehydrationIndex(renderer) {
  if (renderer.selectorPrefix.length === 0 || renderer.selectorPrefix.match(SELECTOR_PREFIX_REGEXP) !== null) {
    return renderer.uniqueRuleIdentifier;
  }

  return -1;
}